import { memo } from 'react';
import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { WorkspaceItemProps } from '../../components/PropTypes';
import { SelectItemContainer, WorkspaceIcon } from '../../components/Atoms';
import { NodeExpander } from '../../components/NodeExpander';

const WorkspaceContainer = styled(FlexBox)`
  line-height: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
`;

const SingleSelectWorkspaceItem = memo(
  ({
    name,
    nodeId,
    containerClassNames,
    containerStyle,
    hasVisibleContent,
    isExpanded,
    ariaAttributes,
  }: WorkspaceItemProps) => {
    return (
      <SelectItemContainer data-id={nodeId} className={containerClassNames}>
        <WorkspaceContainer
          style={containerStyle}
          role="treeitem"
          {...ariaAttributes}
        >
          <NodeExpander
            name={name}
            hasVisibleContent={hasVisibleContent}
            isExpanded={isExpanded}
          />
          <span className="icon-container">
            <WorkspaceIcon />
          </span>
          <span className="workspace-name" role="button">
            {name}
          </span>
        </WorkspaceContainer>
      </SelectItemContainer>
    );
  }
);

export { SingleSelectWorkspaceItem };
